import React from 'react';
import '../applications-css/Application.css'
import '../applications-css/Calculator.css'

class Calculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expression: "0",
      resultCalculated: false,
      lastInput: ""
    };
    this.inputHandler = this.inputHandler.bind(this);
    this.operatorHandler = this.operatorHandler.bind(this);
    this.clearResultBar = this.clearResultBar.bind(this);
    this.calculate = this.calculate.bind(this);
  }

  isNumber(input) {
    return !(isNaN(input));
  }

  inputHandler(input) {
    let tempExpression = this.state.expression;
    if(tempExpression === "0" || this.state.resultCalculated === true) {
      tempExpression = input;
    }
    else {
      tempExpression = "" + tempExpression + input;
    }
    this.setState({
      expression: tempExpression,
      resultCalculated: false,
      lastInput: input
    });
  }

  operatorHandler(input) {
    let tempExpression = this.state.expression;
    if(this.isNumber(this.state.lastInput) === true) {
      tempExpression = tempExpression + " " + input + " ";
    }
    this.setState({
      expression: tempExpression,
      resultCalculated: false,
      lastInput: input
    });
  }

  clearResultBar() {
    this.setState({
      expression: "0",
      resultCalculated: false,
      lastInput: ""
    });
  }

  calculate() {
    if(this.isNumber(this.state.lastInput) === true) {
      // eslint-disable-next-line
      let tempResult = eval(this.state.expression);
      this.setState({
        expression: tempResult,
        resultCalculated: true,
      });
    }
  }

  renderButton(value) {
    return(
      <CalculatorButton
        value = {value}
      />
    );
  }

  renderOperatorButton(value) {
    let clickFunction = this.operatorHandler;
    if(value === "C") {
      clickFunction = this.clearResultBar;
    }
    if(value === "=") {
      clickFunction = this.calculate;
    }
    return(
      <CalculatorButton
        value = {value}
        clickHandler = {clickFunction}
      />
    );
  }

  renderInputButton(value) {
    let clickFunction = this.inputHandler;
    return(
      <CalculatorButton
        value = {value}
        clickHandler = {clickFunction}
      />
    );
  }

  render() {
    return(
      <div className="outsideWrapper">
        <div id="calculatorGrid">
          <ResultBar expression = {this.state.expression}/>
          {this.renderInputButton("7")}
          {this.renderInputButton("8")}
          {this.renderInputButton("9")}
          {this.renderOperatorButton("/")}
          {this.renderOperatorButton("C")}

          {this.renderInputButton("4")}
          {this.renderInputButton("5")}
          {this.renderInputButton("6")}
          {this.renderOperatorButton("*")}
          {this.renderButton(null)}

          {this.renderInputButton("1")}
          {this.renderInputButton("2")}
          {this.renderInputButton("3")}
          {this.renderOperatorButton("-")}
          {this.renderButton(null)}

          {this.renderButton(null)}
          {this.renderInputButton("0")}
          {this.renderButton(null)}
          {this.renderOperatorButton("+")}
          {this.renderOperatorButton("=")}
        </div>
      </div>
    )
  }
}

function ResultBar(props) {
  return(
    <div id="calculatorResultBar">
      <p data-testid="calculator-results">{props.expression}</p>
    </div>
  );
}

function CalculatorButton(props) {
  if(props.value === null) {
    return(<button id="calculatorInputButton" type="button" disabled></button>);
  }
  else {
    let buttonTitle = "button-" + props.value
    return(
      <div>
      <button id="calculatorInputButton"
        data-testid={buttonTitle}
        onClick={() => props.clickHandler(props.value)}>{props.value}
      </button>
      </div>
    );
  }
}

export default Calculator;
